// extracted by mini-css-extract-plugin
export var modalFooter = "_si-0";